<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >公共服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >信息查询服务</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="grid-content bg-purple-dark">
        <p class="tlt1">{{ regulations.laws }}</p>
        <p class="tlt3">
          浏览次数：<span>{{ regulations.num }}</span>
        </p>
        <p class="tlt2">（数据来源：国家文物局文物古迹司）</p>
        <div class="hxl_title"></div>
      </div>
      <div class="announcement">
        <div class="ipt">
          <el-input
            v-model="searchOn"
            maxlength="24rem"
            placeholder="请输入单位名称/法定代表人"
            class="input-with-select"
          >
            <el-button
              class="searchFor"
              slot="append"
              size="small"
              @click="seeSer()"
              >搜索</el-button
            >
          </el-input>
          <el-button size="small" class="reset" @click="resetOn()"
            >重置</el-button
          >
        </div>
        <div style="margin-top: 5px; padding: 0 20px">
          <div style="padding: 20px; border: 1px solid #e6ebf5">
            <el-row>
              <el-col style="font-size: 14px" :span="2">资质类型:</el-col>
              <el-col :span="10">
                <el-checkbox-group
                  class="col"
                  v-model="qualType"
                  @change="qualTypeChange()"
                >
                  <el-checkbox
                    v-for="(item, index) in qualTypeList"
                    :key="index"
                    :label="item.code"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-col>
            </el-row>
            <el-row style="padding: 0 20pxa">
              <el-col style="font-size: 14px" :span="2">业务范围：</el-col>
              <el-col :span="10">
                <el-checkbox-group
                  class="col"
                  v-model="range"
                  @change="rangeChange()"
                >
                  <el-checkbox
                    v-for="(item, index) in rangeList"
                    :key="index"
                    :label="item.code"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="dat">
          <div class="paging">
            <el-select
              clearable
              v-model="state"
              placeholder="省份"
              class="sele"
              @change="stateChange"
            >
              <el-option
                v-for="item in stateList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="refresh"
              @click="refresh()"
              >刷新</el-button
            >
          </div>
        </div>
        <div style="padding: 0 20px; text-align: center">
          <el-table
            v-loading="loading"
            :span-method="objectSpanMethod"
            :data="legalForms"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="organizationName"
              label="单位名称"
              min-width="160px"
            >
              <template slot-scope="scope">
                         
                <span
                  @click="companyFF(scope.row)"
                  style="
                    color: #4b74ff;
                    text-decoration: underline;
                    font-size: 16px;
                    cursor: pointer;
                  "
                  >{{ scope.row.organizationName }}</span
                >                   
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="districtCode"
              label="省份"
              min-width="88px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="type"
              label="资质类型"
              min-width="88px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="range"
              label="业务范围"
              min-width="240px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="legalRepresentative"
              label="法定代表人"
              min-width="110px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="address"
              label="地址"
              min-width="150px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="modified"
              label="更新时间"
              min-width="150px"
              sortable
            >
              <template slot-scope="scope">
                <p style="font-size: 16px">
                  {{ scope.row.modified ? scope.row.modified : "暂无更新时间" }}
                </p>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            popper-class="pageclass"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-col>
    <el-dialog
      width="900px"
      :title="detailsList.organizationName"
      :visible.sync="dialogTableVisible"
    >
      <div class="hxl_titlee"></div>
      <el-scrollbar class="scrollbar" style="height: 400px">
        <div>
          <h4>单位基本信息</h4>
          <table class="mailTable">
            <tr>
              <td class="column">单位名称：</td>
              <td class="row" colspan="2">
                {{ detailsList.organizationName }}
              </td>
              <td class="column">统一社会信用代码：</td>
              <td class="row" colspan="2"></td>
            </tr>
            <tr>
              <td class="column">所属地区：</td>
              <td class="row">{{ detailsList.districtCode }}</td>
              <td class="column">法定代表人：</td>
              <td class="row">{{ detailsList.legalRepresentative }}</td>
              <td class="column">注册资金(万元)：</td>
              <td class="row">{{ detailsList.registeredCapital }}</td>
            </tr>
            <tr>
              <td class="column">经济性质：</td>
              <td class="row">{{ detailsList.organizationNature }}</td>
              <td class="column">联系电话：</td>
              <td class="row">{{ detailsList.telNo }}</td>
              <td class="column">电子邮箱：</td>
              <td class="row">{{ detailsList.email }}</td>
            </tr>
            <tr>
              <td class="column">地址：</td>
              <td class="row" colspan="5">{{ detailsList.address }}</td>
            </tr>
          </table>
          <h4>单位资质信息</h4>
          <el-table
            :data="detailsList.typeList"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="type"
              label="资质类型"
              min-width="150px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="range"
              label="业务范围"
              min-width="468px"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="certificateNum"
              label="资质公布文件"
              min-width="150px"
            >
            </el-table-column>
          </el-table>
          <h4>资格人员列表</h4>
          <el-table
            :data="peoList"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="personName"
              label="姓名"
              min-width="150px"
            >
              <template slot-scope="scope">
                <span
                  @click="nameFF(scope.row)"
                  style="
                    color: #4b74ff;
                    text-decoration: underline;
                    font-size: 12px;
                    cursor: pointer;
                  "
                  >{{ scope.row.personName }}</span
                >                   
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="pcrpersonQualicationTypeName"
              label="资格类型"
              min-width="150px"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="range"
              label="业务范围"
              min-width="460px"
            >
            </el-table-column>
          </el-table>
        </div>
      </el-scrollbar>
    </el-dialog>
    <el-dialog
      width="900px"
      :title="personnelNameList.personName"
      :visible.sync="innerVisible"
    >
      <div class="hxl_titlee"></div>
      <el-scrollbar class="scrollbar" style="height: 400px">
        <div>
          <h4>人员基本信息</h4>
          <table class="mailTable">
            <tr>
              <td class="column">人员姓名：</td>
              <td class="row" colspan="2">
                {{ personnelNameList.personName }}
              </td>
              <td class="column">所在单位：</td>
              <td class="row" colspan="4">
                <span
                  @click="companyFF(personnelNameList)"
                  style="
                    color: #4b74ff;
                    text-decoration: underline;
                    font-size: 12px;
                    cursor: pointer;
                  "
                  >{{ personnelNameList.organizationName }}</span
                >
              </td>
            </tr>
          </table>
          <h4>人员资格信息</h4>
          <el-table
            :data="personnelNameList.typeList"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="type"
              label="资格类型"
              min-width="150px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="range"
              label="业务范围"
              min-width="468px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="certificateNum"
              label="证书编号"
              min-width="150px"
            >
            </el-table-column>
          </el-table>
        </div>
      </el-scrollbar>
    </el-dialog>
  </el-row>
</template>
<script>
import {
  URL_COMPREHENSIVE_EXCUSE,
  URL_PRCUNITID_BY_PRC,
  URL_ONTHELINE_CLICK,
  URL_COMPANY_ID,
  URL_FIND_LIST,
  URL_DESCRIPTION_FIND,
} from "../../../utils/api";
import util from "../../../utils/util";
import Vue from "vue";
import { objectSpan } from "../../../utils/mergecell";
import { frontHeater } from "../../../utils/md5encryption";
export default {
  inject: ["reload"],
  props: [],
  components: {},
  data() {
    return {
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "全国文物保护工程资质单位数据库",
        // 浏览次数
        num: "2",
      },
      loading: false,
      // 资质类型
      qualType: [],
      qualTypeList: [],
      // 业务范围
      range: [],
      rangeList: [],
      //   省份
      stateList: [],
      //省份
      state: null,
      //   搜索
      searchOn: null,
      // 表格
      legalForms: [],
      dialogTableVisible: false,
      innerVisible: false,
      // 点击姓名显示的模块的数据↓↓↓↓↓
      // 获取对应行的id
      personnelNameID: null,
      // 获取根据行获取的数据详情
      personnelNameList: [],
      // 获取点击行的所在单位
      personnelNameOrgan: null,
      // 点击单位显示的模块的数据↓↓↓↓↓
      // 根据单位获取的详情
      detailsList: [],
      // 根据单位获取人员
      peoList: [],
      // 分页表格数据
      schArr: [],
      // 前往页数
      currentPage: 1,
      // 条数
      pagesize: 10,
      total: 0,
      dataList: [{ title: "12" }],
      organId: "",
      provinceArr: [],
    };
  },
  computed: {},
  mounted() {
    this.getQualTypeList();
    this.getrangeList();
    this.getProvinceList();
    this.getNumberViews();
    this.getList();
  },
  methods: {
    flitterData4() {
      let spanOneArr = [];
      let concatOne = 0;
      //let spanOneArr1 = []
      //let concatOne1 = 0
      this.data.forEach((item, index) => {
        if (index === 0) {
          spanOneArr.push(1);
        } else {
          //name 修改
          if (item.appr_inst_name === this.data[index - 1].appr_inst_name) {
            //第一列需合并相同内容的字段
            spanOneArr[concatOne] += 1;
            spanOneArr.push(0);
          } else {
            spanOneArr.push(1);
            concatOne = index;
          }
        }
      });
      return {
        one: spanOneArr,
      };
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (
        columnIndex === 1 ||
        columnIndex === 2 ||
        columnIndex === 5 ||
        columnIndex === 6
      ) {
        const _row_1 = this.provinceArr[rowIndex];
        const _col_1 = _row_1 > 0 ? 1 : 0; //如果被合并了_row=0则它这个列需要取消
        return {
          rowspan: _row_1,
          colspan: _col_1,
        };
      }
    },
    merage() {
      this.merageInit();
      for (let i = 0; i < this.legalForms.length; i++) {
        if (i === 0) {
          //第一行必须存在
          this.provinceArr.push(1);
          this.provincePos = 0;
        } else {
          if (this.legalForms[i].id === this.legalForms[i - 1].id) {
            this.provinceArr[this.provincePos] += 1;
            this.provinceArr.push(0);
          } else {
            this.provinceArr.push(1);
            this.provincePos = i;
          }
        }
      }
    },
    merageInit() {
      this.provinceArr = [];
      this.provincePos = 0;
    },
    // 请求资质类型数据
    getQualTypeList() {
      let result = frontHeater(["ClassCode"], ["PcrunitQualicationTypeCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      const params = {
        ClassCode: "PcrunitQualicationTypeCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] =
        "PcrunitQualicationTypeCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.qualTypeList = res.data.data;
        }
      });
    },
    // 获取业务范围列表
    getrangeList() {
      let result = frontHeater(["ClassCode"], ["PcrunitQualicationRangeCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "PcrunitQualicationRangeCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] =
        "PcrunitQualicationRangeCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.rangeList = res.data.data;
        }
      });
    },
    //获取省份
    getProvinceList() {
      let result = frontHeater(["ClassCode"], ["DistrictCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "DistrictCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "DistrictCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.stateList = res.data.data;
        }
      });
    },
    // 请求数据
    getList() {
      this.loading = true;
      let result = frontHeater(["districtCode"], [this.state]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        keyWord: this.searchOn,
        districtCode: this.state,
        qualification: this.qualType,
        range: this.range,
        pageNation: { pageNumber: this.currentPage, pageSize: this.pagesize },
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["districtCode"] = this.state;
      this.$http.post(Url + URL_FIND_LIST, params).then((res) => {
        if (res.status == 200) {
          this.legalForms = [];
          // let datas = res.data.data.data;
          this.total = res.data.data.total;
          let list = res.data.data.list;
          // this.legalForms = res.data.data.data;
          list.forEach((item) => {
            for (let i of item.dataMap) {
              let obj = {
                organizationId: item.organizationId,
                organizationName: item.organizationName,
                districtCode: item.districtCode,
                address: item.address,
                legalRepresentative: item.legalRepresentative,
                modified: item.modified,
                creditId: item.creditId,
                id: item.id,
                type: i.type,
                range: i.range,
              };
              this.legalForms.push(obj);
            }
            this.merage();
          });
          this.loading = false;
        }
      });
    },
    // 获取点击单位的详细信息
    getListQualifiedPersonnel(id) {
      let result = frontHeater(["pcrunitId"], [id]);
      let Url = util.getAjaxUrl("axiosTWo");
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["pcrunitId"] = id;
      this.$http
        .post(Url + URL_COMPANY_ID, {
          pcrunitId: id,
        })
        .then((res) => {
          if (res.status == 200) {
            this.detailsList = res.data.data;
            this.organId = res.data.data.organizationId;
            this.getPersonnelList();
          }
        });
    },
    // 获取点击单位的详细信息里边的人员信息
    getPersonnelList() {
      console.log(this.organId, "organId");
      let result = frontHeater(["organizationId"], [this.organId]);
      let Url = util.getAjaxUrl("axiosTWo");
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["organizationId"] = this.organId;
      this.$http
        .post(Url + URL_PRCUNITID_BY_PRC, {
          pageNation: { pageNumber: 1, pageSize: 999 },
          organizationId: this.organId,
        })
        .then((res) => {
          if (res.status == 200) {
            let datas = res.data.data;
            debugger;
            this.peoList = datas;
          }
        });
    },
    // 获取点击行的详细信息
    async getPeopleDetail(id) {
      let result = frontHeater(["pcrpersonId"], [id]);
      let Url = util.getAjaxUrl("axiosTWo");
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["pcrpersonId"] = id;
      await this.$http
        .post(Url + URL_ONTHELINE_CLICK, {
          pcrpersonId: id,
        })
        .then((res) => {
          if (res.status == 200) {
            Vue.set(res.data.data, "organizationName", this.personnelNameOrgan);
            Vue.set(res.data.data, "id", this.personnelNameID);
            this.personnelNameList = res.data.data;
          }
        });
    },
    // 获取浏览次数
    getNumberViews() {
      let result = frontHeater(["dataType"], ["DataPrcunitTypeRelevance"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        dataType: "DataPrcunitTypeRelevance",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["dataType"] =
        "DataPrcunitTypeRelevance";
      this.$http.post(Url + URL_DESCRIPTION_FIND, params).then((res) => {
        if (res.status === 200) {
          this.regulations.num = res.data.data.viewTimes;
        }
      });
    },
    // 点击单位获取列表
    companyFF(val) {
      this.getListQualifiedPersonnel(val.id);
      this.personnelNameID = val.id;
      this.dialogTableVisible = true;
      setTimeout(() => {
        this.innerVisible = false;
      }, 50);
    },
    // 点击姓名获取列表
    nameFF(val) {
      this.personnelNameOrgan = val.organizationName;
      this.getPeopleDetail(val.personId);
      this.innerVisible = true;
      setTimeout(() => {
        this.dialogTableVisible = false;
      }, 50);
    },
    // 搜索
    seeSer() {
      this.getList();
    },
    // 重置
    resetOn() {
      this.searchOn = null;
      this.state = null;
      this.qualType = [];
      this.range = [];
      this.currentPage = 1;
      this.getList();
    },
    // 刷新
    refresh() {
      this.resetOn();
    },
    // 解决换页后index从1开始
    // count(index) {
    //   return (this.currentPage - 1) * this.pagesize + index + 1;
    // },
    // 资质类型
    qualTypeChange() {
      this.getList();
    },
    // 业务范围
    rangeChange() {
      this.getList();
    },
    // 确定页数
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    stateChange() {
      this.getList();
    },
  },
};
</script>
<style scoped lang='less'>
@import "../../../styles/theme";
@import "../../../styles/comSty";
@import "../../../styles/Hierarchy";

.el-col-10 {
  width: 90%;
  .col {
    display: flex;
    flex-wrap: wrap;
    /deep/.el-checkbox__label {
      width: 180px;
    }
  }
}

/deep/.el-dialog__header {
  font-size: 14px;
  color: rgb(68, 68, 68);
  text-align: center;
}

.tlt1 {
  font-size: 18px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.tlt2 {
  margin: 0;
  text-align: center;
  font-size: 16px;
}
.tlt3 {
  margin: 0 auto;
  padding-right: 40px;
  text-align: right;
  font-size: 16px;
  color: #444;
  font-weight: 700;
  span {
    color: @theme-color;
  }
}
.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}
.hxl_titlee {
  border-bottom: 3px solid #b71c1c;
}
/deep/.el-dialog__header {
  padding: 20px 0 0;
  font-size: 14px !important;
  color: rgb(68, 68, 68);
}
/deep/.el-dialog__body {
  padding: 10px;
  font-size: 14px !important;
  color: rgb(68, 68, 68);
}
.sele {
  width: 170px;
  height: 32px;
  margin: 10px 0;
}
.dat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  // margin-bottom: 10px;
}
/deep/.el-input--suffix .el-input__inner {
  height: 32px;
  .el-input__icon {
    height: 100%;
    width: 25px;
    text-align: center;
    transition: all 0.3s;
    line-height: 30px;
  }
}
h4 {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
}
　　.mailTable,
.mailTable tr,
.mailTable tr td {
  border: 1px solid #606266;
}
　　.mailTable {
  font-size: 14px;
  color: #606266;
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
}
　　.mailTable tr td {
  border: 1px solid #606266;
  height: 40px;
  box-sizing: border-box;
  line-height: 20px;
  padding: 10px;
}
　.column {
  text-align: center;
  background-color: #ebe6db;
  color: #393c3e;
  width: 150px;
}
.row {
  color: #393c3e;
  text-align: left;
  word-break: break-all;
  word-wrap: break-word;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #b71c1c;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #b71c1c;
  border-color: #b71c1c;
}
.el-table /deep/.descending .sort-caret.descending {
  border-top-color: #b71c1c;
}
.el-table /deep/.ascending .sort-caret.ascending {
  border-bottom-color: #b71c1c;
}
/deep/ .el-loading-spinner .path {
  stroke: red;
}
</style>